import { Grid, Typography } from '@mui/material';
import type { GridSize } from '@mui/material';

type SttLabelFormProps = {
    grid?: boolean;
    title?: string;
    text?: React.ReactNode;
    xs?: GridSize;
    sm?: GridSize;
    md?: GridSize;
    lg?: GridSize;
    xl?: GridSize;
};

/**
 * Label for forms
 */
export function SttLabelForm({
    grid = false,
    xs = 12,
    sm,
    md,
    lg,
    xl,
    title,
    text,
}: SttLabelFormProps) {
    const content = (
        <div className="tw-flex tw-flex-col tw-gap-1">
            <div>
                <Typography variant="caption">{title}</Typography>
            </div>
            <b className="tw-text-base tw-font-semibold tw-text-gray-900">
                {text}
            </b>
        </div>
    );

    return grid ? (
        <Grid size={{ xs, sm, md, lg, xl }}>{content}</Grid>
    ) : (
        content
    );
}
